import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import axios from 'axios';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';

const Register = () => {

    const messageState = useSelector(state => state.message);
    const [firstName, setFirstName] = useState('');  //local hooks
    const [lastName, setLastName] = useState('');  //local hooks
    const [email, setEmail] = useState('');  //local hooks
    const [password, setPassword] = useState('');  //local hooks
    const [passwordConfirm, setPasswordConfirm] = useState('');  //local hooks
    const [captcha, setCaptcha] = useState('');  //local hooks
    const dispatch = useDispatch();  //Assign useDispatch so we can use it...

    const dataPost = {
        firstName: firstName,
        lastName: lastName,
        username: email,
        email: email,
        password: password,
        role: 'ROLE_USER' //default registeration will always start with ROLE_USER
    }

    useEffect(() => {
        dispatch({ type: 'SYSMESSAGE', message: '' });
        loadCaptchaEnginge(8);
    }, [dispatch]);

    const submitRegister = () => {
        //only submit when Captcha is true
        if (validateCaptcha(captcha, false)===true) {
            if(password === passwordConfirm){  //check if password matches confirmPassword, before posting to registeration api
                axios.post('/person/register', dataPost)
                .then(res => {
                    dispatch({ type: 'SYSMESSAGE', message: 'User Registered Successfully...', messageType: 'alert alert-success' });
                    console.log('💾 New user created successfully');
                    
                    console.log('----- Pure res.data -----', res.data);
                }).catch(err => {
                    console.log('❌ Error in Register User: ', err.response);
                    dispatch({ type: 'SYSMESSAGE', message: err.response.data.message, messageType: 'alert alert-danger' });
                });
            }else {
                //setMessageType('alert alert-danger');
                //dispatch(sysmessage('Passwords do not match!')); //set error message to redux state sysmessage...
                dispatch({ type: 'SYSMESSAGE', message: 'Passwords do not match!', messageType: 'alert alert-warning' });
                console.log('*** [Person Register] Password does not match!');
            }
        }
        else {
            dispatch({ type: 'SYSMESSAGE', message: 'Captcha does not match', messageType: 'alert alert-danger' });
        }
    }

    let printMessage = '';
    if(messageState.message){
        printMessage = (
            <div className={messageState.messageType} role="alert">
                {messageState.message}
            </div>
        )
    }
    
    return(
        <>
            <div className="container" style={{ marginTop: 50 }}>
            <div className="form-product-create">
                    <h3>Register</h3>
                    {printMessage}
                    <div className="form-floating">
                        <input type="firstName" className="form-control" placeholder="Your - First Name" 
                            onChange={event => setFirstName(event.target.value)} />
                        <label>First Name</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="lastName" className="form-control" placeholder="Your - Last Name" 
                            onChange={event => setLastName(event.target.value)} />
                        <label>Last Name</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="email" className="form-control" placeholder="Your - Email" 
                            onChange={event => setEmail(event.target.value)} />
                        <label>Email</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="password" className="form-control" placeholder="password (10 characters and above)" 
                            onChange={event => setPassword(event.target.value)} />
                        <label>Pasword</label>
                    </div>
                    <br />

                    <div className="form-floating"> {/* NOTE: Need to fix this... keep showing password if the field is no named password exactly... */}
                        <input type="password" className="form-control" placeholder="password confirm" 
                            onChange={event => setPasswordConfirm(event.target.value)} />
                        <label>Password Confirm</label>
                    </div>
                    <br />

                    <div style={{ display: 'flex', justifyContent:'center', alignItems:'center', width: 620, padding: 10, border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                        < LoadCanvasTemplate reloadColor="red" />

                        <div className="form-floating">
                            <input style={{ width:190 }} type="captcha" className="form-control" placeholder="Enter Captcha" 
                                onChange={event => setCaptcha(event.target.value)} />
                            <label>Captcha</label>
                        </div>
                    </div>

                    <button className="btn btn-primary" onClick={() => submitRegister()}>Register</button>
            </div>
            </div>
        </>
    )
}
export default Register;
